import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { INVENTORY_HD_CONFIG } from "./inventory-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface InventoryProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** Inventory HD — shared ProductDetailHdPage + inventory hero assets. */
export function InventoryProductDetailHd(props: InventoryProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={INVENTORY_HD_CONFIG} />;
}
